export const getShopList = state => {
    return state.list
}

export const getShopDataProps = state => {
    return state.props
}

export const getZohoBranches = state => {
    return state.zoho_branches
}

export const getZohoETABranches = state => {
    return state.zoho_eta_branches
}


// WEBPACK FOOTER //
// ./src/store/modules/shop/getters.js